import classNames from 'classnames';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import FormPopupStatic from './FormPopupStatic';
import ArrowRight from 'assets/arrowRight.svg';
import { useTranslation } from 'next-i18next';

const CTAFormPopup = ({ id, hasNav, filledHeader, popupId, hasSticky }) => {
  const router = useRouter();
  const [formData, setFormData] = useState(null);
  const { t } = useTranslation('common');

  const offer = {
    tr: 'Şimdi Formu Doldurun',
    'en-US': 'Fill out the form now',
    de: 'Füllen Sie das Formular aus',
    ru: 'Заполните форму.',
  };

  // useEffect(() => {
  //   const fetchLang = async () => {
  //     const res = await fetch(`${process.env.API_URL}umbraco/api/Dictionary/GetDictionaryEntries?language=en-US`, {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     });

  //     if (!res.ok) {
  //       throw new Error(`Fetch failed with status ${res.status}`);
  //     }

  //     const data = await res.json();
  //     console.log(data);
  //   };

  //   fetchLang();
  // }, []);

  const addQueryParam = (params) => {
    router.replace(
      {
        query: { ...router.query, ...params },
      },
      undefined,
      { shallow: true },
    );
  };

  const handleForm = async () => {
    try {
      const res = await fetch(`/api/umbraco/forms/api/v1/definitions/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!res.ok) {
        throw new Error(`Fetch failed with status ${res.status}`);
      }

      const data = await res.json();
      const formModule = {
        formFields: {
          ...data,
          pages: data.pages ?? [],
        },
        languages: ['en', 'de', 'ru', 'tr'],
      };

      setFormData({
        formModule,
      });

      addQueryParam({ form: true, id: id, popupId: popupId });
    } catch (err) {
      console.error('Error fetching form:', err);
    }
  };

  return (
    <div>
      {hasNav && !hasSticky && (
        <button
          className={classNames(
            filledHeader ? 'caja-btn-filled' : 'caja-btn',
            'btn ml-5 h-[34px] sm:h-[42px] xl:h-13 py-2 sm:py-3 xl:py-3.5 px-5 sm:px-10 xl:px-[46px]',
          )}
          onClick={handleForm}
        >
          <span className="text-xs leading-4.5 xl:text-sm xl:leading-5">
            {t('general.$contact').toLocaleUpperCase(router.locale)}
          </span>
        </button>
      )}
      {!hasNav && !hasSticky && (
        <button
          className={classNames(
            'btn caja-btn h-[34px] sm:h-[42px] xl:h-13 py-2 sm:py-3 xl:py-3.5 px-5 sm:px-10 xl:px-[46px] mb-10 lg:mb-16',
          )}
          onClick={handleForm}
        >
          <span className="text-xs leading-4.5 whitespace-nowrap xl:text-sm xl:leading-5">{offer[router.locale]}</span>
          <ArrowRight className="ml-6" role="presentation" />
        </button>
      )}
      {hasSticky && (
        <button className={classNames(' btn primary-caja small rounded-sm px-8')} onClick={handleForm}>
          <span className="text-xs leading-4.5 xl:text-sm xl:leading-5">
            {t('general.$contact').toLocaleUpperCase(router.locale)}
          </span>
        </button>
      )}
      {formData && <FormPopupStatic popupId={popupId} form={formData.formModule} />}
    </div>
  );
};

export default CTAFormPopup;
